<template>
  <div class="hero">
    <div class="container container-small">
      <TextSection :header="header" :description="description" :cutLengthTextBig="240" class="header"/>
    </div>
    <div class="hero-animation">
      <div class="container container-small" v-if="items">
        <TextSlider :items="items" class="text-m"/>
      </div>
      <img src="@/assets/images/fmk/hero/animation.gif" alt="animation">
    </div>
    <ScrollToNext v-if="!isPhone && visible"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import TextSlider from '@/components/TextSlider.vue'
import ScrollToNext from '@/components/ScrollToNext.vue'

export default {
  name: 'heroSlider',
  props: ['items', 'header', 'description', 'visible'],
  components: {
    TextSection,
    TextSlider,
    ScrollToNext
  },
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null
    }
  },
  methods: {
    showNext () {
      if (!this.items) { return false }
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop && this.items) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      if (!this.items) { return false }
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    }
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  mounted () {
    setTimeout(this.loopNext, 10000)
  }
}
</script>

<style scoped lang="scss">
  .hero {
    // height: calc(100vh - 77px);
    overflow: hidden;
    position: relative;

    /deep/ {
      .parts-wrapper {
        margin-left: 0;
      }
      .button-scroll {
        bottom: 3vh;
      }
    }
    @include screen ('md') {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      min-height: calc(100vh - 80px);
      // padding-bottom: 25em;
      /deep/ .parts-wrapper {
        margin-left: 110px;
      }
    }
  }
  .header {
    display: block;
    position: relative;
    top: -70px;
    left: 0;
    width: 470px;
    z-index: 1;
    text-align: left;
    animation-name: headeranimation;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-duration: 3s;
    @include mobile {
      // position: static;
      top: 0;
      width: 100%;
    }
  }

  .container {
    position: relative;
    min-height: 12em;
    padding-top: 77px;
    // @include mobile {
    //   height: calc(100vh - 16px);
    //   padding-top: 0;
    // }
    .slider {
      @include mobile {
        // bottom: -78px;
        bottom: 0;
        color: $text-dark;
        // .font-size-l & {
        //   bottom: -110px;
        // }
      }
    }
    .header-options {
      position: absolute;
      top: calc(100vh - 190px);
      left: 0;
      z-index: 9999;
    }
  }
  .slide {
    display: none;
    transition: $transitionSlider;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    text-align: left;
    height: 100%;
    align-items: center;
    font-weight: 500;
    &.prev {
      display: flex;
      transform: translateX(-100vw);
      opacity: 0.3;
    }
    &.next {
      display: flex;
      transform: translateX(100vw);
      opacity: 0.3;
    }
    &.active {
      display: flex;
      transform: translateX(0);
      opacity: 1;
    }
  }
  .controllers {
    position: absolute;
    z-index: 3;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 90px;
    height: 100%;
    button {
      border: 0;
      background-color: transparent;
      box-shadow: none;
      outline: none;
      &:focus {
        outline: none;
      }
      font-size: 0;
      color: transparent;
      &.prev {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &.next {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    svg {
      width: 40px;
      height: 40px;
    }
    @include mobile {
      display: none;
    }
  }
  .slide-wrapper {
    position: relative;
    width: 350px;
    max-width: 90vw;
    overflow: hidden;
    height: 70px;
    text-align: left;
    margin-left: 100px;
    @include mobile {
      margin-left: 0;
      width: 100%;
    }
  }
  .slider {
    position: absolute;
    z-index: 3;
    bottom: 0;
    left: -18px;
    animation-name: slideranimation;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-duration: 3s;
    @include mobile {
      left: 0;
      width: 100%;
    }
  }
  .hero-animation {
    transition: $transitionSliderImage;
    transform: translateX(0);
    opacity: 1;
    position: relative;
    right: 0;
    z-index: 9;
    width: 100%;
    text-align: right;
    overflow: hidden;

    @include screen ('md') {
      bottom: 0;
      height: 100%;
      position: absolute;
      right: 0;
      width: 100%;

      .container {
        bottom: 20%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 20;
      }
    } // END @include screen ('md');

    // @include screen ('min-height') {
    //   .container {
    //     bottom: 20%;
    //   }
    // }

    img {
      max-width: 60vw;
      // max-height: 100%;
      position: relative;
      right: -3vw;

      @include screen ('sm') {
        margin-bottom: -130px;
        top: -130px;
      }

      @include screen ('md') {
        bottom: 0;
        height: auto;
        max-height: 100vh;
        margin: 0;
        position: absolute;
        top: auto;
        max-width: 60vw;
      }

    }

  }
  @keyframes headeranimation
  {
    0%
    {
      transform: translateY(50%);
      opacity: 0;
    }
    50%
    {
      transform: translateY(50%);
      opacity: 0;
    }
    100%
    {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes slideranimation
  {
    0%
    {
      transform: translateX(90vw);
    }
    55%
    {
      transform: translateX(90vw);
    }
    100%
    {
      transform: translateX(0);
    }
  }
</style>
